import type { TrackedButtonClickName } from '~/services/gtm.client';
import gtm from '~/services/gtm.client';
import { getPreviousPagePosition } from '~/utils/navigationContext';

import UserEvent from './UserEvent';

type EventData = {
  buttonName: TrackedButtonClickName;
  isBot: boolean;
  pagePosition: string;
};

class SignUpMethodEvent extends UserEvent<EventData> {
  sendToGtm() {
    gtm.pushToDataLayer({
      button_name: this.data.buttonName,
      event: 'sign_up_method',
      page_position: this.data.pagePosition,
      previous_page_position: getPreviousPagePosition()
    });
  }

  collectServerEvents() {
    this.serverEvents.push({
      data: {
        button_name: this.data.buttonName,
        page_position: this.data.pagePosition,
        previous_page_position: getPreviousPagePosition()
      },
      type: 'sign_up_method'
    });
  }
}

export default SignUpMethodEvent;
